export default __webpack_public_path__ + "ff9e4bbc9f6152a668e2c87a71ca02b0.png";